import TaskListEnums from '@/commons/TaskListEnums';

export default [
  // Trang công việc
  {
    path: 'task',
    name: 'TaskPage',
    component: () => import('@/views/task/TaskPage.vue'),
    redirect: { name: 'all' },
    // meta: {},
    /**
     * Tôi cần thực hiện
     */
    children: [
      {
        path: 'all',
        name: 'all',
        component: () => import('@/views/task/TaskPage.vue'),
        subsystemCode: "TaskList",
        meta: {
          title: 'Tất cả công việc',
          mode: TaskListEnums.TaskListMode.listAllTask,
        },
      },
      {
        path: 'needtodo',
        name: 'needtodo',
        subsystemCode: "TaskList",
        component: () => import('@/views/task/TaskPage.vue'),
        meta: {
          title: 'Công việc tôi cần thực hiện',
          mode: TaskListEnums.TaskListMode.listNeedToDo,
        },
      },
      {
        path: 'assignedbyme',
        name: 'assignedbyme',
        subsystemCode: "TaskList",
        component: () => import('@/views/task/TaskPage.vue'),
        meta: {
          title: 'Công việc tôi đã giao/phụ trách',
          mode: TaskListEnums.TaskListMode.listAssignedByMe,
        },
      },
      {
        path: 'donebyme',
        name: 'donebyme',
        subsystemCode: "TaskList",
        component: () => import('@/views/task/TaskPage.vue'),
        meta: {
          title: 'Công việc tôi đã thực hiện',
          mode: TaskListEnums.TaskListMode.listDone,
        },
      },
      {
        path: 'needtoapprove',
        name: 'needtoapprove',
        subsystemCode: "TaskList",
        component: () => import('@/views/task/TaskPage.vue'),
        meta: {
          title: 'Công việc tôi cần phê duyệt',
          mode: TaskListEnums.TaskListMode.listNeedToApprove,
        },
        children: [
          {
            path: 'approveupdatedeadline',
            name: 'approveupdatedeadline',
            subsystemCode: "TaskList",
            component: () => import('@/views/task/TaskPage.vue'),
            meta: {
              title: 'Công việc tôi cần phê duyệt',
              mode: TaskListEnums.TaskListMode.listApproveUpdateDeadline,
            },
          },
        ]
      },
      {
        path: 'relatedtome',
        name: 'relatedtome',
        subsystemCode: "TaskList",
        component: () => import('@/views/task/TaskPage.vue'),
        meta: {
          title: 'Công việc liên quan đến tôi',
          mode: TaskListEnums.TaskListMode.listInvolve,
        },
      },
      {
        path: 'draft',
        name: 'draft',
        subsystemCode: "TaskList",
        component: () => import('@/views/task/TaskPage.vue'),
        meta: {
          title: 'Dự thảo',
          mode: TaskListEnums.TaskListMode.listDraft,
        },
      },
    ],
  },
];
